module.exports = "/_next/static/images/Hero-fa76e55c3423f696277409738a3a4b39.webp";